import camelCaseKeys from 'camelcase-keys'

export class ExternalId {
  constructor (params = {}) {
    const {
      id,
      created,
      service,
      serviceId,
      qualifier
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.created = created || null
    this.serviceId = serviceId || null
    this.service = service || this.serviceId
    this.qualifier = qualifier || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      serviceId: item.serviceId
    }
  }
}
